/* eslint-disable import/no-anonymous-default-export */
import { SendMailState, SET_SEND_MAIL_INITIAL_STATE, SET_NEXT_KEY_PICKER_COMPONENT_TO, SET_NEXT_KEY_PICKER_COMPONENT_CC, UPDATE_SEND_MAIL_STATE, SendMailActionTypes } from './types'

const setInitialState = (): SendMailActionTypes => {
    return {
        type: SET_SEND_MAIL_INITIAL_STATE,
    }
}

const setNextKeyPickerComponentTo = (): SendMailActionTypes => {
    return {
        type: SET_NEXT_KEY_PICKER_COMPONENT_TO
    }
}

const setNextKeyPickerComponentCc = (): SendMailActionTypes => {
    return {
        type: SET_NEXT_KEY_PICKER_COMPONENT_CC
    }
}

const updateState = (newState: Partial<SendMailState>): SendMailActionTypes => {
    return {
        type: UPDATE_SEND_MAIL_STATE,
        payload: newState
    }
}

export default {
    setInitialState,
    setNextKeyPickerComponentTo,
    setNextKeyPickerComponentCc,
    updateState,
    //...
}